// extracted by mini-css-extract-plugin
export var parcelRow = "_rt-0";